import request from '@/utils/request'

// 获取导航菜单树2
export function treeWithProduct() {
  return request({
    url: '/website/menu/treeWithProduct',
    method: 'get'
  })
}
// 获取导航菜单树
export function getMenuTree() {
  return request({
    url: '/website/menu/tree',
    method: 'get'
  })
}

// 获取Banner列表
export function getBanners() {
  return request({
    url: '/website/banner/list',
    method: 'get',
    params: { status: '0', pageSize: 100 }
  })
}

// 获取企业介绍
export function getCompanyIntro() {
  return request({
    url: '/website/intro/list',
    method: 'get',
    params: { status: '0', pageSize: 1 }
  })
}

// 获取页脚信息树（前台展示用）
export function getFooterTree() {
  return request({
    url: '/website/footer/active/tree',
    method: 'get'
  })
}

// 获取客服信息
export function getContact() {
  return request({
    url: '/website/contact/list',
    method: 'get',
    params: { pageSize: 1 }
  })
}
// 获取学校列表
export function getPartner() {
  return request({
    url: '/website/partner-university/list',
    method: 'get',
    params: { pageNum: 1,pageSize:9999 }
  })
}

